var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.7578,
    r: 27.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.7578,
    r: 26.75,
    stroke: "#7C684E",
    strokeOpacity: 0.26,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4877 38.1323C15.0413 37.8744 14.8858 37.301 15.1722 36.872C16.3849 35.0554 18.0007 33.538 19.8982 32.4414C22.0658 31.1889 24.5245 30.5294 27.0273 30.5294C29.5302 30.5294 31.9889 31.1889 34.1565 32.4414C36.054 33.538 37.6698 35.0554 38.8825 36.872C39.1689 37.301 39.0134 37.8744 38.567 38.1323C38.1206 38.3903 37.5526 38.2349 37.262 37.8087C36.216 36.2748 34.8368 34.9922 33.2231 34.0596C31.3393 32.971 29.2025 32.3979 27.0273 32.3979C24.8522 32.3979 22.7154 32.971 20.8316 34.0596C19.2179 34.9922 17.8387 36.2748 16.7927 37.8087C16.5021 38.2349 15.9341 38.3903 15.4877 38.1323Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5915 23.3936C32.5915 20.4138 30.1782 17.9983 27.2012 17.9983C24.2243 17.9983 21.8109 20.4138 21.8109 23.3936C21.8109 26.3734 24.2243 28.789 27.2012 28.789V30.5294C23.2639 30.5294 20.0721 27.3346 20.0721 23.3936C20.0721 19.4526 23.2639 16.2578 27.2012 16.2578C31.1385 16.2578 34.3303 19.4526 34.3303 23.3936C34.3303 27.3346 31.1385 30.5294 27.2012 30.5294V28.789C30.1782 28.789 32.5915 26.3734 32.5915 23.3936Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f779e714e78f51b1e38040b45a4f0e53.svg";
export { ForwardRef as ReactComponent };